import { useEffect, useState } from "react";
import { useParams, useSearchParams, useLocation } from "react-router-dom";
import PublicLayout from "../components/PublicLayout";
import { ArticleListItem } from "../components/ArticleCard";
import { PopularSidebar } from "../components/Sidebars";
import AdSlot from "../components/AdSlot";
import api from "../lib/api";

export default function ListingPage({ mode }) {
  // mode: news | featured | latest | popular | category | author | search
  const { slug } = useParams();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const [items, setItems] = useState([]);
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(true);

  const q = searchParams.get("q") || "";

  useEffect(() => {
    setLoading(true);
    const params = { limit: 30 };
    let title = "Notícias";
    let sub = "";
    if (mode === "featured") { params.featured = true; title = "Destaques"; sub = "As reportagens em evidência"; }
    else if (mode === "latest") { title = "Últimas Notícias"; sub = "As publicações mais recentes"; }
    else if (mode === "popular") { params.sort = "popular"; title = "Notícias Populares"; sub = "As mais lidas do portal"; }
    else if (mode === "category") {
      params.category = slug;
      title = slug?.toUpperCase();
      sub = "Editoria";
      api.get(`/categories`).then(r => {
        const c = (r.data || []).find(x => x.slug === slug);
        if (c) setMeta({ ...c, type: "category" });
      });
    } else if (mode === "author") {
      params.author = slug;
      api.get(`/authors/${slug}`).then(r => setMeta({ ...r.data, type: "author" })).catch(() => setMeta(null));
    } else if (mode === "search") {
      params.q = q;
      title = `Busca: "${q}"`;
      sub = "Resultados encontrados";
    }
    api.get("/articles", { params }).then(r => {
      setItems(r.data.items || []);
      if (!meta) setMeta({ title, sub, type: "static" });
      setLoading(false);
    });
    window.scrollTo(0, 0);
  // eslint-disable-next-line
  }, [mode, slug, q, location.key]);

  return (
    <PublicLayout>
      <div className="max-w-7xl mx-auto px-4 py-8 grid lg:grid-cols-3 gap-10" data-testid={`listing-${mode}`}>
        <div className="lg:col-span-2">
          {meta?.type === "author" ? (
            <div className="mb-8 border-b border-zinc-300 pb-6 flex items-center gap-6" data-testid="author-header">
              {meta.avatar && <img src={meta.avatar} alt={meta.name} className="w-24 h-24 object-cover" />}
              <div>
                <p className="overline text-zinc-500">Autor</p>
                <h1 className="font-serif-display text-4xl font-bold">{meta.name}</h1>
                {meta.bio && <p className="font-body text-zinc-700 mt-2 max-w-2xl">{meta.bio}</p>}
              </div>
            </div>
          ) : (
            <div className="hairline-accent pt-3 mb-6">
              <h1 className="font-serif-display text-4xl font-bold">{meta?.name || meta?.title}</h1>
              {(meta?.sub || meta?.description) && <p className="font-body text-zinc-600 mt-1">{meta?.sub || meta?.description}</p>}
            </div>
          )}

          {loading ? (
            <p className="font-sans-ui text-zinc-500">Carregando...</p>
          ) : items.length === 0 ? (
            <p className="font-sans-ui text-zinc-500 py-12 text-center border border-zinc-200">Nenhuma notícia encontrada.</p>
          ) : (
            <ul>
              {items.map(a => <ArticleListItem key={a.id} article={a} />)}
            </ul>
          )}
        </div>
        <aside className="space-y-8">
          <PopularSidebar />
          <AdSlot placement="sidebar" />
        </aside>
      </div>
    </PublicLayout>
  );
}
